"use client";

import { HeartIcon as OutlinedHeartIcon } from "@heroicons/react/24/outline";
import { HeartIcon } from "@heroicons/react/24/solid";

import { useFavoriteMedia } from "../../hooks/useFavoriteMedia";

export const AddButton = ({ mediaId }: { mediaId: string }) => {
  const { isFavorite, toggleFavorite } = useFavoriteMedia({ mediaId });

  return (
    <button
      aria-label="add to favorites"
      className="group/icon flex cursor-pointer items-center justify-center rounded-md bg-zinc-800/30 p-0.5 transition-colors hover:bg-zinc-600"
      onClick={(e) => {
        e.stopPropagation();
        toggleFavorite();
      }}
    >
      {isFavorite ? (
        <HeartIcon className="h-6 w-6 text-red-500" />
      ) : (
        <OutlinedHeartIcon className="h-6 w-6 text-zinc-200" />
      )}
    </button>
  );
};
